const NS = 'HomepageCourseCarouselBlock';
const CLS = 'homepageCourseCarouselBlock';

import { compactViewMixinBlock } from '../../mixins/compactViewMixinBlock/compactViewMixinBlock';
import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { backgroundWaveMixinBlock } from '../../mixins/backgroundWaveMixinBlock/backgroundWaveMixinBlock';
import { backgroundRippleMixinBlock } from '../../mixins/backgroundRippleMixinBlock/backgroundRippleMixinBlock';

export class HomepageCourseCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$elementInner = this.$element.find(`.${CLS}-inner`);
		this.$sliderContainer = this.$element.find(`.${CLS}-sliderContainer`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);
		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.$carouselSlider.slick({
			dots: true,
			dotsClass: `slick-dots`,
			appendArrows: this.$sliderContainer,
			appendDots: this.$sliderContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-left"></i></button>`,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			mobileFirst: false,
			cssEase: 'ease-in-out',
			useTransform: true,
			responsive: [
				{
					breakpoint: 450,
					settings: {
						centerMode: true,
						centerPadding: '15px',
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		this.$carouselSlider.on('beforeChange', (_event, slick, currentSlide, nextSlide) => {
			$(slick.$slides[currentSlide]).find('.card').removeClass('active');
			$(slick.$slides[nextSlide]).find('.card').addClass('active');
		});

		this.initCompactView(this);
		this.initFullWindowHeight(this);

		this.$carouselItems.css({ opacity: 1 });
		this.adjustArrowVisibility();

		$(window).resize(_.debounce(() => {
			this.adjustArrowVisibility();
		}, 50, { trailing: true }));

		this.initBackgroundWave(this);
		this.initBackgroundRipple(this);

		// Re-render text so ellipsis displays, a known issue for visibility: hidden.
		setTimeout(() => {
			this.$carouselSlider.find('.card').each((index, element) => {
				let $title = $(element).find('.card-title');
				$title.text($title.text());
			});
		}, 500);
	}

	adjustArrowVisibility() {
		let $arrows = this.$element.find(`.slick-arrow`);
		if(!($arrows && $arrows.length > 0)) {
			return;
		}

		let previousArrow = this.$element.find(`.slick-arrow--previous`);
		let nextArrow = this.$element.find(`.slick-arrow--next`);

		previousArrow.css({
			visibility: Math.floor(previousArrow.offset().left) < 0 ? 'hidden' : 'visible'
		});

		nextArrow.css({
			visibility: (Math.ceil(nextArrow.offset().left + nextArrow.width()) + 1) >= this.getContainerWidth() ? 'hidden' : 'visible'
		});
	}

	getContainerWidth() {
		let $tplContent = $('.tpl-content');
		if($tplContent && $tplContent.length > 0) {
			return $tplContent.width();
		}
		return $(window).width();
	}
}

Object.assign(HomepageCourseCarouselBlock.prototype, compactViewMixinBlock);
Object.assign(HomepageCourseCarouselBlock.prototype, fullWindowHeightMixinBlock);
Object.assign(HomepageCourseCarouselBlock.prototype, backgroundWaveMixinBlock);
Object.assign(HomepageCourseCarouselBlock.prototype, backgroundRippleMixinBlock);

